import { createSlice } from "@reduxjs/toolkit";

const CuetSlice = createSlice({
  name: "CuetDetails",
  initialState: {
    currentCuetPracticeData: {},
    currentCuetSubjectData: {},
    currentCuetTopicData: {},
  },

  reducers: {
    setCurrentCuetSubject: (state, action) => {
      state.currentCuetSubjectData = action.payload;
    },

    setCurrentCuetTopic: (state, action) => {
      state.currentCuetTopicData = action.payload;
    },

    setCurrentCuetPractice: (state, action) => {
      state.currentCuetPracticeData = action.payload;
    },
  },
});

export const {
  setCurrentCuetPractice,
  setCurrentCuetSubject,
  setCurrentCuetTopic,
} = CuetSlice.actions;

export default CuetSlice.reducer;
